import type { CSSObject, SxProps, Theme } from "@mui/material/styles";

import { Box } from "@mui/material";
import GlobalStyles from "@mui/material/GlobalStyles";
import { useTheme } from "@mui/material/styles";
import { Dialog } from "app/components/dialog/Dialog";

import { baseVars, layoutClasses } from "../settings";

export type LayoutSectionProps = {
  children?: React.ReactNode;
  cssVars?: CSSObject;
  footerSection?: React.ReactNode;
  headerSection?: React.ReactNode;
  sidebarSection?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export function LayoutSection({
  children,
  cssVars,
  footerSection,
  headerSection,
  sidebarSection,
  sx,
}: LayoutSectionProps) {
  const theme = useTheme();

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        body: {
          ...baseVars(theme),
          ...cssVars,
        },
      }}
    />
  );

  return (
    <>
      {inputGlobalStyles}

      <Box className={layoutClasses.root} id="root__layout" sx={sx}>
        {sidebarSection}
        <Box
          className={layoutClasses.hasSidebar}
          display="flex"
          flex="1 1 auto"
          flexDirection="column"
        >
          {headerSection}
          {children}
          {footerSection}
        </Box>
        <Dialog />
      </Box>
    </>
  );
}
